import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { UnidadeProvider } from "@/contexts/UnidadeContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Movements from "@/pages/Movements";
import EpiDeliveries from "@/pages/EpiDeliveries";
import CommunityPurchases from "@/pages/CommunityPurchases";
import PaymentOrders from "@/pages/PaymentOrders";
import Suppliers from "@/pages/Suppliers";
import SupplierPurchases from "@/pages/SupplierPurchases";
import Requisitions from "@/pages/Requisitions";
import Communities from "@/pages/Communities";
import Cooperados from "@/pages/Cooperados";
import Sectors from "@/pages/Sectors";
import Collaborators from "@/pages/Collaborators";
import Users from "@/pages/Users";
import Reports from "@/pages/Reports";
import Print from "@/pages/Print";
import Scan from "@/pages/Scan";
import Tickets from "@/pages/Tickets";
import Returns from "@/pages/Returns";
import Vehicles from "@/pages/Vehicles";
import FuelRequests from "@/pages/FuelRequests";
import FuelOuts from "@/pages/FuelOuts";
import FuelApprove from "@/pages/FuelApprove";
import RequisitionApprove from "@/pages/RequisitionApprove";
import MyPin from "@/pages/MyPin";
import ComprasDashboard from "@/pages/ComprasDashboard";
import ComprasPriceBulk from "@/pages/ComprasPriceBulk";
import AuditLogs from "@/pages/AuditLogs";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center font-mono-data text-sm">
        Carregando...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !(user.role === "admin" || roles.includes(user.role))) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <UnidadeProvider>
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/aprovar-combustivel/:token" element={<FuelApprove />} />
              <Route path="/aprovar-requisicao/:token" element={<RequisitionApprove />} />
              <Route path="/imprimir/:tipo/:id" element={<Protected><Print /></Protected>} />
              <Route path="/" element={<Protected><Layout /></Protected>}>
                <Route index element={<Dashboard />} />
                <Route path="bipar" element={<Scan />} />
                <Route path="produtos" element={<Products />} />
                <Route path="movimentacoes" element={<Protected roles={["almoxarife", "compras"]}><Movements /></Protected>} />
                <Route path="epis" element={<Protected roles={["almoxarife"]}><EpiDeliveries /></Protected>} />
                <Route path="tickets" element={<Protected roles={["almoxarife"]}><Tickets /></Protected>} />
                <Route path="compras-comunidade" element={<Protected roles={["almoxarife", "compras"]}><CommunityPurchases /></Protected>} />
                <Route path="fornecedores" element={<Protected roles={["almoxarife", "presidencia", "compras"]}><Suppliers /></Protected>} />
                <Route path="compras-fornecedor" element={<Protected roles={["almoxarife", "compras"]}><SupplierPurchases /></Protected>} />
                <Route path="ordens-pagamento" element={<Protected roles={["admin", "compras", "tesoureiro", "presidencia"]}><PaymentOrders /></Protected>} />
                <Route path="requisicoes" element={<Requisitions />} />
                <Route path="devolucoes" element={<Protected roles={["almoxarife", "presidencia"]}><Returns /></Protected>} />
                <Route path="veiculos" element={<Protected roles={["almoxarife", "tesoureiro", "presidencia"]}><Vehicles /></Protected>} />
                <Route path="combustivel" element={<FuelRequests />} />
                <Route path="saidas-combustivel" element={<Protected roles={["almoxarife", "tesoureiro", "presidencia"]}><FuelOuts /></Protected>} />
                <Route path="meu-pin" element={<MyPin />} />
                <Route path="comunidades" element={<Protected roles={["almoxarife", "presidencia", "compras"]}><Communities /></Protected>} />
                <Route path="cooperados" element={<Protected roles={["almoxarife", "presidencia", "compras"]}><Cooperados /></Protected>} />
                <Route path="setores" element={<Protected roles={["almoxarife"]}><Sectors /></Protected>} />
                <Route path="colaboradores" element={<Protected roles={["almoxarife"]}><Collaborators /></Protected>} />
                <Route path="usuarios" element={<Protected roles={[]}><Users /></Protected>} />
                <Route path="relatorios" element={<Reports />} />
                <Route path="compras" element={<Protected roles={["compras", "presidencia"]}><ComprasDashboard /></Protected>} />
                <Route path="compras/precos" element={<Protected roles={["compras"]}><ComprasPriceBulk /></Protected>} />
                <Route path="auditoria" element={<Protected roles={["presidencia"]}><AuditLogs /></Protected>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </UnidadeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
